import http from '../../../plugins/axios';

export default {

    getUserInfoList() {
        return http.get({
           url : '/admin/auth/userList'
        })
    },

    alertUserAuthInfo(data) {
        return http.post({
            url : '/admin/auth/alter',
            data,
            dataType: 'form'
        })
    },

    resetUserAuth(data) {
        return http.post({
            url : '/admin/auth/reset',
            data,
            dataType: 'form'
        })
    },

    queryPassphraseConf(data) {
        return http.get({
            url : '/admin/auth/passphrase/conf/query',
            data
        })
    },

    buildPassphraseConf(data) {
        return http.post({
            url: '/admin/auth/passphrase/conf/build',
            data,
            dataType: 'form'
        })
    },

    insertAdminUser(data) {
        return http.post({
            url : '/admin/auth/addAdminUser',
            data,
            dataType: 'form'
        })
    },

    deleteAdminUser(data) {
        return http.post({
            url : '/admin/auth/removeAdminUser',
            data,
            dataType: 'form'
        })
    },

    syncAdminUserInfo(){
        return http.post({
            url: '/admin/auth/sync/user',
        })
    },

    addAdminUserRole(data) {
        return http.post({
            url: '/admin/auth/role',
            data,
            dataType: 'form'
        })
    }
}
